<table>
  <colgroup>
    <col/>
  </colgroup>
  <colgroup class="ny-beholdning">
    <col class="nummer"/>
    <col span="6"/>
  </colgroup>
  <!--<colgroup class="eksisterende-beholdning">
    <col class="nummer"/>
    <col span="4"/>
  </colgroup>-->
  <thead>
  <tr class="tittelrad--gruppering">
    <th class="navn"></th>
    <th colspan="6">{{ "Ny beholdning" | translate }}</th>
    <!--<th colspan="5">Eksisterende beholdning</th>-->
    <!-- <th class="sp-uten-strek-under"></th>-->
  </tr>
  <tr class="tittelrad--kolonner">
    <th class="navn">{{ "Navn" | translate }}</th>
    <th class="nummer">{{ "Aksjenummer" | translate }}</th>
    <th class="antall">{{ "Antall" | translate }}</th>
    <th class="diff differanse-rad">{{ "Endring" | translate }}</th>
    <th class="andel">{{ "Eierandel" | translate }}</th>

    <!--<th class="nummer">Aksjenummer</th>
    <th class="antall">Antall</th>
    <th class="andel">Eierandel</th>-->
    <th class="klasse">{{ "Klasse" | translate }}</th>
    <th class="innføringsdato">{{ "Innføringsdato" | translate }}</th>
    <!-- <th>Kommentar</th>-->
  </tr>
  </thead>

  @for (beholdningmodell of modell.beholdninger; track beholdningmodell.aksjeeier.id){
    <tbody>
    <tr data-testid="aksjeeier" [ngClass]="{'positiv':beholdningmodell.antallAksjerDifferanse() > 0, 'negativ':beholdningmodell.antallAksjerDifferanse() < 0, 'samme':beholdningmodell.erEndret() && beholdningmodell.antallAksjerDifferanse() == 0, 'uendret':!beholdningmodell.erEndret()}">
      <td class="navn">{{ beholdningmodell.aksjeeier.navn }}</td>
      <td class="nummer">{{ beholdningmodell.aksjenummerFeltverdi() }}</td>
      <td class="antall">{{ beholdningmodell.antallAksjer() }}</td>
      <!--unngå mellomrom mellom <span> og verdi for å unngå avstand mellom '+' og verdi -->
      <td class="diff"><span class="diff--sirkel">{{ beholdningmodell.antallAksjerDifferanse() }}</span></td>
      <td class="andel">{{ beholdningmodell.eierandel() | percent }}</td>

     <!-- <td class="nummer">{{ beholdningmodell.aksjeeier.naavaerendeBeholdning?.aksjenummer }}</td>
      <td class="antall">{{ beholdningmodell.aksjeeier.naavaerendeBeholdning?.antall }}</td>
      <td class="andel">{{ beholdningmodell.aksjeeier.naavaerendeBeholdning?.eierandel | prosent }}</td>-->
      <td class="klasse">{{ beholdningmodell.aksjeklasseKtrl.value?.navn }}</td>
      <td class="innføringsdato">
        @if (beholdningmodell.erEndret()){
          {{ innfoeringsdato | plaindate:'medium' }}
        } @else {
          {{ beholdningmodell.aksjeeier.naavaerendeBeholdning?.gyldigFraTil?.start | plaindate:'medium' }}
        }
      </td>

      <!--<td><div class="align-med-mat-form-field-dense-3" [innerHtml]="modell.aksjeeier.naavaerendeBeholdning?.kommentar">></td>-->
    </tr>
    </tbody>
  }

  <tfoot>
  <tr [ngClass]="{'positiv':modell.totaltAntallAksjerDifferanse() > 0, 'negativ':modell.totaltAntallAksjerDifferanse() < 0, 'uendret':modell.totaltAntallAksjerDifferanse() == 0}">
    <td class="navn"><!--navn-->{{ "Totalt" | translate }}</td>
    <td class="nummer">{{ modell.aksjenummerIBruk()|aksjenummerintervaller }}</td>
    <td class="antall">{{ modell.totaltAntallAksjer() }}</td>
    <!--unngå mellomrom mellom <span> og verdi for å unngå avstand mellom '+' og verdi -->
    <td class="diff"><span class="diff--sirkel">{{ modell.totaltAntallAksjerDifferanse() }}</span></td>
    <td class="andel"><!--eierandel--></td>

    <!--<td class="nummer">{{ modell.eksisterendeAksjenummerIBruk|aksjenummerintervaller }}</td>
    <td class="antall">{{ modell.eksisterendeTotaltAntallAksjer }}</td>
    <td class="andel">&lt;!&ndash;eierandel&ndash;&gt;</td>-->
    <td class="klasse">
      @if (modell.totaltAntallAksjerPerAksjeklasse().size > 1){
        <antall-aksjer-per-aksjeklasse [aksjeklasserMedAntall]="modell.totaltAntallAksjerPerAksjeklasse()"/>
      }
    </td>
    <td class="innføringsdato"><!--innføringsdato--></td>
  </tr>
  </tfoot>

</table>

@if (modell.aksjenummerIkkeIBruk().length > 0 || modell.totaltAntallAksjerDifferanse() != 0) {
  <div class="meldinger-til-bruker">
    @if (modell.aksjenummerIkkeIBruk().length > 0) {
      <inline-melding type="feil">
        {{ "Aksjene {aksjenummerintervaller} mangler eier" | translate: {aksjenummerintervaller: modell.aksjenummerIkkeIBruk()|aksjenummerintervaller} }}
      </inline-melding>
    }

    @if (modell.totaltAntallAksjerDifferanse() != 0) {
      <inline-melding type="info">
        {{ "Totalbeholdning endres fra {eksisterendeTotaltAntallAksjer} til {totaltAntallAksjer}" | translate: {totaltAntallAksjer: modell.totaltAntallAksjer(),  eksisterendeTotaltAntallAksjer: modell.eksisterendeTotaltAntallAksjer} }}
      </inline-melding>
    }
  </div>
}
